import { foundationCheckboxStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
import { PrimaryRapidColorHEX, ColorHEX } from '../_common';
export const zeroCheckboxStyles = (context, definition) => css `
  ${foundationCheckboxStyles(context, definition)}
  :host {
    --primary-gradient-angle: -113.5deg;
    --foreground-on-accent-rest: ${ColorHEX.white};
    --foreground-on-accent-hover: ${ColorHEX.white};
    --neutral-stroke-hover: ${ColorHEX.white};
    --foreground-on-accent-active: ${ColorHEX.white};
  }

  .checked-indicator {
    background-image: linear-gradient(
      var(--primary-gradient-angle),
      ${PrimaryRapidColorHEX.blue},
      ${PrimaryRapidColorHEX.purple}
    );
    background-origin: border-box;
    box-shadow: 2px 1000px 1px rgb(0 0 0 / 20%) inset;
    border-radius: calc(var(--control-corner-radius) * 1px);
  }
`;
